export default __webpack_public_path__ + "static/media/web-illustration.26e665ca.png";